import type { EventCategoryDTOWithId, LocalizedEventCategoryEntityDTO } from '@carlito/hotel-apis';

import type { ListEventCategoriesController } from '@carlito/hotel-apis';
import { ControllerExecutionSuccessResult, ControllerQueryParameters } from '@carlito/ddd';
import { bookitoRequest } from './api';

export type ListEventCategoriesQueryParameters<T extends boolean = boolean> = Omit<
  ControllerQueryParameters<ListEventCategoriesController>,
  'localize'
> & {
  localize?: T;
};

export type ListEventCategoriesResponse =
  ControllerExecutionSuccessResult<ListEventCategoriesController>;

type ConditionalResponse<T extends boolean> = Omit<
  ListEventCategoriesResponse,
  'eventCategories'
> & {
  eventCategories: T extends true ? LocalizedEventCategoryEntityDTO[] : EventCategoryDTOWithId[];
};

export type LocalizedEventCategory = LocalizedEventCategoryEntityDTO;
export type EventCategory = EventCategoryDTOWithId;

export async function listEventCategories<T extends boolean>(
  params: ListEventCategoriesQueryParameters<T>
): Promise<ConditionalResponse<T>> {
  const result = await bookitoRequest<ListEventCategoriesController>('/event-category', {
    queryParameters: {
      ...params,
      localize: params.localize ? 'true' : '',
    },
  });

  return result as ConditionalResponse<T>;
}
